import { useEffect, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { updateVendorCompensationPlan } from '../../actions/vendor.action'
import { vendorFormAction } from "../../reducers/vendor.reducer";
import ApiClient from "../../apis/apiClient";
import { API_GetAllSubscriptionList, } from "../../apis/constant";
import { toast } from "react-toastify";

const FormCompensationPlan = ({ isNew }) => { 
  const adminToken = localStorage.getItem("wed_admin_token");
  const vendor = useSelector((state) => state.vendorSlice.vendor);
  const [subsrciption, setSubscrption] = useState([])
  const vendorForm = useSelector((state) => state.vendorSlice.vendorForm);
  const dispatch = useDispatch();
  const initialCompensationPlan = {
    sellerDiscPercentage: 0,
    commissionId: "",
    subscriptionPeriod: "",
    subscription: 0,
    subscriptionName: "",
    subscriptionId: "",
    commissionPlan: "",
    commissionPercentage: 0,
  }

  //const compensationDetails = useRef(initialCompensationPlan)

  const getAllSubscriptionList = async (limit, search = "", pageNumber) => {
    const data = "";

    const res = await ApiClient.get(API_GetAllSubscriptionList + `?page=${pageNumber}&sortBy=asc&limit=${limit}&searchBy=${search}`,
      data,
      `Bearer ${adminToken}`
    );
    if (res.data.code === 200) {
      if (res.data.data.docs && res.data.data.docs.length !== 0) {
        setSubscrption(res.data.data.docs);
      }
    }
  }

  const setSubscriptionDetails = (subscriptionId) => {
    if(subsrciption.length === 0) {
      return false;
    }
    const sub = subsrciption.find(x => x.id === subscriptionId);
    
    if(!vendorForm?.sellerOffering?.services[0]?.id) {  
      toast.error("Please complete seller offering section first!")
      return false;
    }
    let plan = initialCompensationPlan;
    if (sub) {
      const category = sub.discountPlan.find(x => x.masterCategory === vendorForm?.sellerOffering?.services[0]?.id)
      plan = { ...plan, subscriptionPeriod: sub.type, subscription: sub.fee, commissionPlan: sub.name, subscriptionName: sub.name, subscriptionId: sub.id, commissionId: sub.commissionId, commissionPercentage: category ? category.commission : 0, sellerDiscPercentage: category ? category.sellerDisc : 0 }
    }
    dispatch(vendorFormAction({
      ...vendorForm,
      compensationPlan: plan,
    }));
  }


  useEffect(() => {
    getAllSubscriptionList(20, '', 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vendorForm?.compensationPlan?.subscriptionId && subsrciption.length > 0) {
      setSubscriptionDetails(vendorForm?.compensationPlan?.subscriptionId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subsrciption])

  // const handleChangeForm = (title, value) => {
  //   let compensation = {
  //     [title]: value,
  //   }
  //   compensationDetails.current = { ...compensationDetails.current, ...compensation }
  //   dispatch(
  //     vendorFormAction({
  //       ...vendorForm,
  //       compensationPlan: {
  //         ...vendorForm.compensationPlan,
  //         ...compensation,
  //       },
  //     })
  //   );
  //   // getAllSubscriptionList(20, '', 1);
  // };

  const handleUpdate = () => {
    if (vendorForm?.compensationPlan?.subscriptionId && vendorForm?.compensationPlan?.commissionId && vendorForm?.compensationPlan?.subscriptionId !== "" && vendorForm?.compensationPlan?.commissionId !== "") {
      dispatch(
        updateVendorCompensationPlan({
          params: {
            id: vendor.id,
            compensationPlan: vendorForm?.compensationPlan
          },
          onSuccess: () => {
            toast.success("Vendor Updated Successfully!")
            window.location.reload();

          },
          onFailed: () => { },
        })
      )
    } else {
      toast.error("Please Select Compensation Plan")
    }
  }

  return (
    <div className="md:mt-10 mt-5 animate-fade-in-down">
      <div className="md:flex md:space-x-2 md:space-y-0 space-y-3">
        <div className="w-full space-y-2">
          <p>Commission Plan</p>
          <select
            value={vendorForm?.compensationPlan?.subscriptionId}
            onChange={(e) => {
              setSubscriptionDetails(e.target.value);
            }}
            className="w-full outline-none border border-bg-primary rounded-sm py-1 px-2"
          >
            <option value={""}>Select Plan</option>
            {subsrciption && subsrciption.map(item =>
              (<option value={item.id}>{item.name}</option>))}
          </select>
        </div>
        <div className="w-full space-y-2">
          <p>Commission %</p>
          <input
            disabled
            type="number"
            // onChange={(e) =>
            //   handleChangeForm("commissionPercentage", e.target.value)
            // }
            value={vendorForm?.compensationPlan?.commissionPercentage}
            className="w-full outline-none border border-bg-primary rounded-sm py-1 px-2"
          />
        </div>
        <div className="w-full space-y-2">
          <p>Seller Disc %</p>
          <input
            disabled
            // onChange={(e) =>
            //   handleChangeForm("sellerDiscPercentage", e.target.value)
            // }
            value={vendorForm?.compensationPlan?.sellerDiscPercentage ?? 0}
            type="number"
            className="w-full outline-none border border-bg-primary rounded-sm py-1 px-2"
          />
        </div>
      </div>
      <div className="md:flex md:space-x-2 md:space-y-0 space-y-3 mt-5">
        <div className="w-full space-y-2">
          <p>Subscription S$</p>
          <input
            disabled
            type="number"
            className="w-full outline-none border border-bg-primary rounded-sm py-1 px-2"
            // onChange={(e) => handleChangeForm("subscription", e.target.value)}
            value={vendorForm?.compensationPlan?.subscription}
          />
        </div>
        <div className="w-full space-y-2">
          <p>Subscription Name</p>
          <input
            disabled
            // onChange={(e) => handleChangeForm("subscriptionName", e.target.value)}
            value={vendorForm?.compensationPlan?.subscriptionName}
            type="text"
            className="w-full outline-none border border-bg-primary rounded-sm py-1 px-2"
          />
        </div>
        <div className="w-full space-y-2">
          <p>Subscription Period</p>
          <select
            disabled
            // onChange={(e) => handleChangeForm("subscriptionPeriod", e.target.value)}
            value={vendorForm?.compensationPlan?.subscriptionPeriod}
            className="w-full outline-none border border-bg-primary rounded-sm py-1 px-2"
          >
            <option value="Monthly">Monthly</option>
            <option value="Quarterly">Quarterly</option>
          </select>
        </div>
      </div>
      {!isNew && <button
        className={`py-2 px-4 mt-5 mr-2 rounded shadow-sm text-white w-full bg-bg-primary hover:bg-bg-primary-darker transition-all`}
        onClick={() => handleUpdate()}
      >
        Update
      </button>}
      {/* <div className="md:flex md:space-x-2 md:space-y-0 space-y-3 mt-5">
        <div className="w-full space-y-2">
          <p>Advertising $$</p>
          <input
            type="number"
            className="w-full outline-none border border-bg-primary rounded-sm py-1 px-2"
          />
        </div>
        <div className="w-full space-y-2">
          <p>Advertising %</p>
          <input
            type="number"
            className="w-full outline-none border border-bg-primary rounded-sm py-1 px-2"
          />
        </div>
      </div> */}
    </div>
  );
};

const CompensationPlan = ({ isNew }) => {
  const [openForm, setOpenForm] = useState(false);

  return (
    <div className="w-full shadow-xl px-5 py-5 bg-white">
      <div
        onClick={() => setOpenForm(!openForm)}
        className="flex justify-between cursor-pointer"
      >
        <p className="text-xl">Compensation Plan</p>
        <BsChevronDown
          size={25}
          className={
            "text-bg-primary " +
            (openForm ? "rotate-180 transition-all" : "rotate-0 transition-all")
          }
        />
      </div>
      {openForm && <FormCompensationPlan isNew={isNew} />}
    </div>
  );
};

export default CompensationPlan;
